module.exports = __webpack_public_path__ + "static/media/64.32d3764f.png";